import { createPinia, setActivePinia } from 'pinia';
import { analyticsPlugin } from './stores/plugins/analytics.plugin';
import { sessionPlugin } from './stores/plugins/session.plugin';

export const pinia = createPinia();
// Required before vueApp.use(pinia): auth initialization runs before initVueApp(),
// and early initialization paths call useOrganizationStore()
// at action-invocation time. Without this, those calls throw "No active Pinia".
setActivePinia(pinia);

pinia.use(analyticsPlugin);
pinia.use(sessionPlugin);
